import { isPaidParam } from 'lib/GoogleAnalytics';
import { useMemo } from 'react';

export const SESSION_KEY = 'is_paid';

const setIsPaidInSession = (isPaid: boolean): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(SESSION_KEY, isPaid.toString());
  }
};

const getIsPaidFromSession = (): boolean => {
  if (typeof window === 'undefined') return false;

  const storedValue = sessionStorage.getItem(SESSION_KEY);
  return storedValue ? storedValue === 'true' : false;
};

export default function useIsPaid(): boolean {
  const queryValue = useMemo(() => {
    if (typeof window === 'undefined') return false;

    const searchParams = new URLSearchParams(window.location.search);
    return isPaidParam(searchParams.get('p') || undefined);
  }, []);
  const sessionValue = getIsPaidFromSession();

  if (queryValue) setIsPaidInSession(true);

  return !!queryValue || !!sessionValue;
}
